import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/common/coming-soon/coming-soon';

export const Route = createFileRoute('/_authenticated/_tenant/history')({
  component: () => <ComingSoon title="History" />,
});
